var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{staticClass:"right-align-number-input",attrs:{"items":['00:30', '01:00', '02:00', '03:00'],"outlined":"","dense":_vm.dense,"placeholder":_vm.$t('plannedService.durationInputPlaceholder'),"rules":[
    ..._vm.rules,
    (v) =>
      _vm.isValid(v) || _vm.$t('plannedService.invalidDurationInput'),
  ],"hide-details":"auto"},model:{value:(_vm.duration),callback:function ($$v) {_vm.duration=$$v},expression:"duration"}})
}
var staticRenderFns = []

export { render, staticRenderFns }